/**
 * 外部データの更新設定
 */
export enum UpdateKinds {
  /** 更新しない */
  None = 1,
  /// <summary>外部データ：自動設定「する」</summary>
  ExternalDataEditStarted = 2,
  /// <summary>外部データ：自動設定「しない」</summary>
  ExternalDataClicked = 4,
  /** 書類登録時 */
  DocumentSaved = 8,
  /** 一時保存時 */
  DocumentTemporarySaved = 16,
  /** 書類登録時・一時保存時 */
  DocumentSavedAndTemporarySaved = 32,
  /** 計算時 */
  Calculated = 64,
  /** クリック時 */
  Clicked = 128,
  /** 記載開始時（新規・修正） */
  EditStart = 256,
  /** 自動更新（外部データ） */
  Auto = 512,
}
